import { concurrent } from './concurrent';
import { custom, interaction, pageLoad, pageSegmentLoad } from './core';
export var metrics = {
  pageLoad: pageLoad,
  pageSegmentLoad: pageSegmentLoad,
  interaction: interaction,
  custom: custom,
  concurrent: concurrent
};